import { Palette } from '../../palettes/palettes';

export function TooltipFromRaster({ palette, value }: { palette: Palette; value: number }) {
    if (palette.noTooltip) {
        return null;
    }

    if (palette.type === 'discreteBar') {
        if (palette.tooltipSingleValue) {
            return (
                <div>
                    {palette.getValue ? palette.getValue(value) : palette.values[value]}
                    {palette.suffix} {palette.units}
                </div>
            );
        }
        const upperLimit = palette.getValue ? palette.getValue(value) : palette.values[value];
        const currentValue = palette.getValue ? palette.getValue(value - 1) : palette.values[value - 1];
        return (
            <div className="d-flex align-items-center gap-2">
                <div className="border" style={{ height: '15px', width: '15px', backgroundColor: palette.colors[value] }}></div>
                <span>
                    {!upperLimit && <span>&gt;= </span>}
                    {currentValue}
                    {palette.suffix}
                    {upperLimit && (
                        <span>
                            {' '}
                            to &lt; {upperLimit}
                            {palette.suffix}{' '}
                        </span>
                    )}
                    {palette.units}
                </span>
            </div>
        );
    } else if (palette.type === 'gradientBar') {
        if (palette.getValue) {
            if (palette.tooltipSingleValue) {
                return (
                    <div>
                        {palette.getValue(value)}
                        {palette.suffix} {palette.units}
                    </div>
                );
            }

            return (
                <div>
                    {palette.getValue(value - 1)}
                    {palette.suffix} to &lt; {palette.getValue(value)}
                    {palette.suffix} {palette.units}
                </div>
            );
        }
        return <div>{value}</div>;
    } else if (palette.type === 'combined') {
        let offset = 0;
        for (const p of palette.palettes) {
            if (p.offset > value) {
                break;
            }
            offset = p.offset;
        }
        const upperLimit = palette.values[value - offset];

        return (
            <div className="d-flex align-items-center gap-2">
                <div className="border" style={{ height: '15px', width: '15px', backgroundColor: palette.colors[value] }}></div>
                <span>
                    {!upperLimit && <span>&gt;= </span>}
                    {palette.values[value - offset - 1]}
                    {palette.suffix}
                    {upperLimit && (
                        <span>
                            {' '}
                            to &lt; {upperLimit}
                            {palette.suffix}{' '}
                        </span>
                    )}
                    {palette.units}
                </span>
            </div>
        );
    } else if (palette.type === 'categorical') {
        if (value >= palette.entries.length) {
            return null;
        }

        return (
            <div className="d-flex gap-2 align-item-center">
                <div className="border" style={{ height: '15px', width: '15px', backgroundColor: palette.entries[value].color }}></div>
                {palette.entries[value].label} {palette.units}
            </div>
        );
    }
    return null;
}
